
webpack.register(
    'modules/sideline-games/sideline-games',
    function() {
        return import('modules/sideline-games/sideline-games');
    },
    true
);